import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListComponent } from '@spartacus/organization/administration/components';
import { SplitViewComponent, ViewComponent, PopoverDirective, IconComponent, TableComponent, FocusDirective, PaginationComponent } from '@spartacus/storefront';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { RouterLinkActive, RouterLink, RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, UrlPipe } from '@spartacus/core';

enum ICON_TYPE {
  PLUS = 'PLUS'
}

@Component({
    selector: 'app-efa-manage-users-list',
    templateUrl: './efa-manage-users-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SplitViewComponent, ViewComponent, PopoverDirective, IconComponent, NgSelectComponent, FormsModule, NgOptionComponent, RouterLinkActive, RouterLink, TableComponent, FocusDirective, PaginationComponent, RouterOutlet, AsyncPipe, TranslatePipe, UrlPipe]
})
export class EfaManageUsersListComponent extends ListComponent {
 readonly customIconTypes = ICON_TYPE;
}
